// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__hbs5E","popup":"Popup_popup__PugWK","closeBtn":"Popup_closeBtn__7W8TW"};